import React from 'react';

import { Heading, Container, Row, Col } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import CardStoreComponent from '../CardStoreComponent';

import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';
import style from './style.module.scss';

export default function StoresSection({
    title,
    titleTag,
    id,
    stores,
    allStores,
    showDescription,
    buttons,
    colorScheme,
    detachDesktop,
    pt,
    disableTags,
    utm,
}) {
    colorScheme = colorScheme?.toLowerCase();
    const hasColorScheme = colorScheme !== 'none';

    return (
        <section
            aria-labelledby={id}
            className={`${sectionStyle['with-bg']} ${sectionStyle['with-bg--none']
                } ${colorStyle[`with-bg--${colorScheme}`]}`}
        >
            {hasColorScheme ? (
                <div
                    data-sal="fade"
                    data-sal-easing="ease-out-quart"
                    className={`${sectionStyle.bg} ${colorStyle.bg}`}
                />
            ) : null}
            <Container
                pt={pt ? pt : { xs: hasColorScheme ? 10 : 15, lg: 20 }}
                pb={{ xs: hasColorScheme ? 0 : 10, lg: 10 }}
            >
                <Row>
                    {title ? (
                        <Col>
                            <Heading
                                id={id}
                                className={`h3 mb-5 mb-lg-6 ${style.heading}`}
                                tag={titleTag}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {title}
                            </Heading>
                        </Col>
                    ) : null}
                    {stores.map((store, i) => (
                        <Col
                            key={i}
                            col={{
                                xs: allStores ? 6 : 12,
                                md: allStores ? 4 : 6,
                                lg: allStores ? 3 : detachDesktop ? 6 : 4,
                            }}
                            mb={{
                                xs: allStores ? 5 : 10,
                                lg: 10,
                            }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            data-sal-delay={`xs-none--lg-${(i % (allStores ? 4 : detachDesktop ? 2 : 3)) *
                                100
                                }`}
                        >
                            <CardStoreComponent
                                allStores={allStores}
                                utm={utm}
                                {...store}
                                aspectRatioDesktop={
                                    !allStores && detachDesktop ? 2 : null
                                }
                                min={allStores}
                                tags={disableTags ? [] : store.tags}
                                showDescription={showDescription}
                            />
                        </Col>
                    ))}
                    {buttons && buttons.length ? (
                        <Col
                            className="text-center"
                            mb={{ xs: 10 }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            <ButtonComponent buttons={buttons} focusWhite={colorScheme == 'primary' ? true : false} />
                        </Col>
                    ) : null}
                </Row>
            </Container>
        </section>
    );
}
